import {
  ensure,
  wrapErrors,
  notEmpty,
  ensureProperties,
  itsProperty,
  validateNotOverlapingOf,
} from "../Common/composition";
import SelectAvailableDevice from "./SelectAvailableDevice";
const compare = (one, another) => one.interface === another.interface;
const describe = (interface_) => `device ${interface_}`;

const validateInterface = wrapErrors(
  (error) => `interface ${error}`,
  ensure(notEmpty)
);

const validateInterfaceEntry = wrapErrors(
  (error) => `Interfaces ${error}`,
  ensure(
    ensureProperties(itsProperty("interface", validateInterface)),
    validateNotOverlapingOf(compare, describe)
  )
);

const listPresentInterfacesAsString = ({
  added = [],
  updated = [],
  keeped = [],
}) =>
  [...keeped, ...added, ...updated].map((item) => item["interface"]).join(" ");

export const interfaceComposition = {
  cliType: "interface",
  typeLabel: "Interface",
  viewURL: "viewInterfaceProfileConfig",
  expectClear: true,
  expectSet: true,
  profileFn: (row)=>{
    return {
      stored: true, 
      pristine: true,
      name: row["NAME"],
      interfaces: row["DEVICE"].map(item=> {
        return {
          interface: item["DEVICE"]
        };
      })
    }
  },
  fields: [
    { name: "name", label: "Profile name", type: "text", canUpdate: true, resName: "NAME", numeric: false },
    {
      name: "interfaces",
      cliName: "interface-id",
      label: "input interfaces",
      labelSingle: "input interface",
      type: "many",
      resName: "DEVICE",
      cliExpressAs: listPresentInterfacesAsString,
      canBeEmpty: false,
      validate: validateInterfaceEntry,
      numeric: true,
      fields: [
        {
          name: "interface",
          label: "Interface",
          type: "select",
          InputComponent: SelectAvailableDevice,
          editionClassName: "full-width",
          validate: validateInterface,
          resName: "DEVICE",
          numeric: true,
        },
      ],
    },
  ],
};

export default interfaceComposition;
